export default "__VITE_ASSET__61bc8990__"